// The node kinds of a parsed `Math` expression — binary ops, unary negate, and
// the `QUANTITY` leaf. Used as the `enum` discriminant of each `Math` node.
export const enum Operation {
  ADD = "Add",
  SUB = "Sub",
  MUL = "Mul",
  DIV = "Div",
  NEG = "Neg",
  NUM = "Num",
  SYM = "Sym",
  MIN = "Min",
  MAX = "Max",
  WITH = "With",
}
